import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=018f7306&scoped=true&lang=pug&"
import script from "./Ship.vue?vue&type=script&lang=js&"
export * from "./Ship.vue?vue&type=script&lang=js&"
import style0 from "./Ship.vue?vue&type=style&index=0&id=018f7306&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f7306",
  null
  
)

export default component.exports